import * as React from 'react';
import Svg, { G, Path } from 'react-native-svg';

const AndroidTv: React.FC<SvgProps> = ({ color, ...props }) => (
  <Svg
    width="127.19"
    height="22.0021"
    viewBox="0 0 127.19 22.0021"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <G>
      <Path
        d="M6.90874 7.0657C8.97323 7.0657 10.6943 8.12883 11.4958 9.27775V7.35269H14.6491V21.7149H12.5076C11.9489 21.7149 11.4958 21.2618 11.4958 20.7014V19.7918C10.6943 20.9397 8.97323 22.0021 6.90874 22.0021C2.98248 22.0021 0 18.642 0 14.5343C0 10.4265 2.98248 7.0657 6.90874 7.0657ZM7.48239 9.93862C4.9305 9.93862 3.21019 11.9488 3.21019 14.5343C3.21019 17.1189 4.9305 19.1304 7.48239 19.1304C10.0335 19.1304 11.7546 17.1189 11.7546 14.5343C11.7546 11.9488 10.0336 9.93862 7.48239 9.93862Z"
        fill={color || '#FFF'}
      />
      <Path
        d="M18.2304 7.35312H21.3844V9.30624C22.2437 7.8705 23.8785 7.06613 25.742 7.06613C29.0669 7.06613 31.2177 9.42152 31.2177 13.0698V21.7149H29.0754C28.5168 21.7149 28.0637 21.2609 28.0637 20.7013V13.5868C28.0637 11.3179 26.9164 9.93905 25.0829 9.93905C22.9899 9.93905 21.3845 11.5763 21.3845 14.6492V21.7149H19.2413C18.6835 21.7149 18.2304 21.2609 18.2304 20.7013V7.35312Z"
        fill={color || '#FFF'}
      />
      <Path
        d="M40.6212 7.06565C42.6849 7.06565 44.406 8.12879 45.2083 9.2777V0.17233H48.3607V21.7149H46.2192C45.6615 21.7149 45.2083 21.2617 45.2083 20.7013V19.7917C44.406 20.9397 42.6849 22.002 40.6212 22.002C36.6932 22.002 33.7118 18.642 33.7118 14.5342C33.7118 10.4265 36.6933 7.06565 40.6212 7.06565ZM41.195 9.93857C38.6439 9.93857 36.9236 11.9488 36.9236 14.5342C36.9236 17.1189 38.6439 19.1304 41.195 19.1304C43.7451 19.1304 45.4654 17.1189 45.4654 14.5342C45.4654 11.9488 43.7451 9.93857 41.195 9.93857Z"
        fill={color || '#FFF'}
      />
      <Path
        d="M51.9428 7.35312H55.096V9.90956C55.6404 8.27228 57.2459 7.20963 58.8806 7.20963C59.281 7.20963 59.6837 7.23865 60.1135 7.32458V10.5701C59.5674 10.3976 59.1102 10.3117 58.5374 10.3117C56.7308 10.3117 55.0961 11.8348 55.0961 14.7071V21.7149H52.9538C52.3961 21.7149 51.9429 21.2609 51.9429 20.7013V7.35312H51.9428Z"
        fill={color || '#FFF'}
      />
      <Path
        d="M68.6159 22.0021C64.3739 22.0021 61.1052 18.6982 61.1052 14.5351C61.1052 10.3699 64.3739 7.0657 68.6159 7.0657C72.8596 7.0657 76.1268 10.3691 76.1268 14.5351C76.1268 18.6982 72.8596 22.0021 68.6159 22.0021ZM68.6159 19.0733C71.1387 19.0733 72.9166 17.0904 72.9166 14.5351C72.9166 11.9791 71.1385 9.99618 68.6159 9.99618C66.065 9.99618 64.2877 11.9791 64.2877 14.5351C64.2877 17.0904 66.065 19.0733 68.6159 19.0733Z"
        fill={color || '#FFF'}
      />
      <Path
        d="M80.2591 4.22257C79.1126 4.22257 78.1377 3.27567 78.1377 2.09662C78.1377 0.947706 79.1126 3.84656e-06 80.2591 3.84656e-06C81.4341 3.84656e-06 82.3519 0.947866 82.3519 2.09662C82.3519 3.27567 81.4341 4.22257 80.2591 4.22257ZM78.6836 7.35267H81.836V21.7149H79.6945C79.1359 21.7149 78.6836 21.26 78.6836 20.7013V7.35267Z"
        fill={color || '#FFF'}
      />
      <Path
        d="M91.336 7.06565C93.4005 7.06565 95.1208 8.12879 95.9239 9.2777V0.17233H99.0771V21.7149H96.9356C96.376 21.7149 95.9239 21.2617 95.9239 20.7013V19.7917C95.1208 20.9397 93.4005 22.002 91.336 22.002C87.4097 22.002 84.4282 18.642 84.4282 14.5342C84.4282 10.4265 87.4097 7.06565 91.336 7.06565ZM91.9098 9.93857C89.3597 9.93857 87.6394 11.9488 87.6394 14.5342C87.6394 17.1189 89.3597 19.1304 91.9098 19.1304C94.4617 19.1304 96.182 17.1189 96.182 14.5342C96.1818 11.9488 94.4617 9.93857 91.9098 9.93857Z"
        fill={color || '#FFF'}
      />
      <Path
        d="M104.56 9.18H101.474V7.27423H104.56V3.25845H106.577V7.27423H110.787V9.18H106.577V17.5284C106.577 19.2898 107.356 19.9829 108.97 19.9829C109.546 19.9829 110.325 19.8672 110.787 19.6658V21.4851C110.122 21.7453 109.431 21.8609 108.653 21.8609C106.203 21.8609 104.56 20.4445 104.56 17.7004V9.18Z"
        fill={color || '#FFF'}
      />
      <Path
        d="M127.19 7.27373L120.445 21.7166H118.859L112.113 7.27373H114.362L119.637 18.741L124.913 7.27373H127.19Z"
        fill={color || '#FFF'}
      />
    </G>
  </Svg>
);

export default AndroidTv;
